interface Props {
  readonly slug?: string | undefined
}

/**
 * Shown when a hosting window has run out.
 *
 * The edge function redirects here rather than serving a dead end, because an
 * expired page is the one moment a founder is guaranteed to be looking. Lead
 * with renewal, not with an apology.
 */
export function Expired({ slug }: Props) {
  return (
    <div className="centered">
      <main className="notice">
        <h1>This page has landed</h1>
        <p>
          {slug ? <><code>{slug}.simplelaunch.io</code> was live here, but its</> : 'This page’s'}{' '}
          hosting window has ended.
        </p>
        <div className="notice-actions">
          {slug && <a className="cta-link" href={`/?renew=${slug}`}>Bring it back</a>}
          <a className="ghost-link" href="/">Start a new one</a>
        </div>
      </main>
    </div>
  )
}
